export default "__VITE_ASSET__DljBsmXJ__"